const n = (...r) => (...t) => {
  r.forEach((e) => e == null ? void 0 : e(...t));
};
function o(r) {
  return function(e = {}) {
    return {
      ...e,
      ...r(e || {})
    };
  };
}
export {
  n as composeHandlers,
  o as createPropsGetter
};
